import axios from 'axios'
import { IAuthRefresToken } from '@interfaces/index'
import { AuthService } from '@services/index'
import { removeEmptyParams } from '@services/middlewares/removeEmptyParams'

async function refreshTokenReq(): Promise<IAuthRefresToken> {
    const refreshToken = localStorage.getItem('refreshToken')
    if (!refreshToken) throw new Error('Refresh token not found')
    return await AuthService.refreshToken(refreshToken)
}

const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
})

api.interceptors.request.use(
    async (config) => {
        const token = localStorage.getItem('accessToken')

        if (config.headers) {
            config.headers['System-Origin'] = 'ADMIN'
            if (token) config.headers.Authorization = `Bearer ${token}`
        }

        if (token && config.headers) config.headers.Authorization = `Bearer ${token}`

        if (config.params) {
            removeEmptyParams(config)
        }

        return config
    },
    (error) => Promise.reject(error)
)

api.interceptors.response.use(
    (response) => response,
    async function err(requestError) {
        const refreshToken = localStorage.getItem('refreshToken')
        const originalRequest = requestError.config

        if (originalRequest.url === '/users/refresh-token') {
            return Promise.reject(requestError)
        }
        if (requestError.response && requestError.response.status === 401 && refreshToken && !originalRequest._retry) {
            originalRequest._retry = true
            try {
                const response = await refreshTokenReq()
                localStorage.setItem('accessToken', response.data.accessToken)
                return api(originalRequest)
            } catch {
                localStorage.clear()
                window.location.href = '/'
            }
        } else {
            return Promise.reject(requestError)
        }
        return Promise.reject(requestError)
    }
)

export default api
